import Card from '../Card/Index'
import styles from './Grid.module.css'

export default function Grid({lista}) {
    return (
        <div className={styles.container}>
            <ul className={styles.lista}>
                {lista.map((formacao) => <li key={formacao.id}><Card item={formacao}/></li>)}
            </ul>
        </div>
    )
}
